import DOMPurify from "dompurify";

/**
 * SafeRichText — renders trusted-but-sanitised HTML produced by the RichTextEditor.
 *
 * Strict allowlist mirrors what the editor can emit (bold, italic, paragraphs,
 * line breaks, bullet & ordered lists, headings H2/H3, links, and text-align
 * inline style). Any other HTML — scripts, images, iframes, on* handlers — is
 * stripped.
 *
 * Props:
 *  - html: string — content from RichTextEditor.
 *  - className?: string — extra classes (defaults to readable prose styling).
 *  - testId?: string
 */
export default function SafeRichText({ html, className = "", testId }) {
  if (!html) return null;
  const clean = DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ["p", "br", "strong", "b", "em", "i", "u", "ul", "ol", "li", "a", "h2", "h3", "span"],
    ALLOWED_ATTR: ["href", "target", "rel", "style"],
    // Restrict `style` to text-align only — strips any other inline styling.
    ALLOWED_CSS_PROPERTIES: ["text-align"],
  });
  return (
    <div
      className={`[&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5 [&_p]:my-1 [&_a]:text-indigo-600 [&_a]:underline [&_h2]:text-xl [&_h2]:font-semibold [&_h2]:mt-4 [&_h2]:mb-2 [&_h3]:text-base [&_h3]:font-semibold [&_h3]:mt-3 [&_h3]:mb-1 ${className}`}
      data-testid={testId}
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
}
